import React from 'react';

const AboutMe = () => {
  return (
    <>
<p className="mb-4">Hey there! I'm Smit Khobragade (He/Him), a dedicated Full-Stack Developer and final-year Computer Science student at Shri Ramdeobaba College of Engineering and Management, Nagpur.</p>
      <p className="mb-4">I specialize in the MERN stack (MongoDB, Express.js, React, Node.js) and have a strong interest in building robust, efficient solutions. Open-source contributions energize me, and I'm enthusiastic about collaborating with forward-thinking teams.</p>
      <p className="mb-4">Previously, I served as President of the Geeks For Geeks RCOEM Chapter, organizing successful events like Git For Geeks 2.0 and the ICPC Challenge. I believe in creating impactful learning experiences and enjoy fostering a collaborative environment.</p>
      <p className="mb-4">Let’s connect and create something amazing! 🚀</p>
      <p className="mb-2"><strong>Email:</strong> <a href="mailto:smitkbgd@gmail.com" className="text-blue-500">smitkbgd@gmail.com</a></p>
      <p className="mb-2"><strong>Links:</strong> <a href="https://linktr.ee/smitkhobragade" className="text-blue-500">Linktree</a> | <a href="https://github.com/Smitkhobragade" className="text-blue-500">GitHub</a></p>
    </>
  );
}

export default AboutMe;
